import { isDetachedPortalApp } from '@/utils/portalMode'

function parseHostsFromEnv(): string[] {
  const raw = import.meta.env.VITE_CLIENT_PORTAL_HOSTS
  if (!raw || typeof raw !== 'string') return []
  return raw
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean)
}

/**
 * Optional local-preview host list. Production branding is resolved by
 * GET /client/portal-config — this env var is not an allowlist.
 */
export function getClientPortalHosts(): string[] {
  return [...new Set(parseHostsFromEnv())]
}

/**
 * True when the app is served from a client-portal-only host
 * (e.g. clients.valt.africa). Detached portal builds are always portal-only.
 */
export function isClientPortalHost(hostname?: string): boolean {
  if (isDetachedPortalApp()) return true
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
  if (!host) return false
  if (host.startsWith('clients.')) return true
  return getClientPortalHosts().includes(host)
}

export function isContractorAppPath(pathname: string): boolean {
  return (
    pathname === '/clients/login' ||
    pathname === '/clients/change-password' ||
    pathname.startsWith('/clients/recover-password') ||
    pathname === '/contractor' ||
    pathname.startsWith('/contractor/')
  )
}
